<template>
	<div class="box" v-parallax-fit="box">
		<img class="region-1" ref="region_1" v-parallax-fit="region_1"
			src="/themes/rise-theme/dist/images/estate/character-view/ozzie/01_Detroit@2x.png" alt="">
		<img class="region-2" v-parallax-fit="region_2"
			src="/themes/rise-theme/dist/images/estate/character-view/ozzie/01_Mexico@2x.png" alt="">

		<div class="route-plane">
			<img ref="plane" class="plane" v-parallax-fit="plane"
				src="/themes/rise-theme/dist/images/estate/character-view/ozzie/02_plane@2x.png" alt="">
			<img class="route" v-parallax-fit="route"
				src="/themes/rise-theme/dist/images/estate/character-view/ozzie/03_PlanePath@2x.png" alt="">
			<img class="photo photo-1" v-parallax-fit="photo_1"
				src="/themes/rise-theme/dist/images/estate/character-view/ozzie/04_OzzieFamily_01@2x.png" alt="">
			<img class="photo photo-2" v-parallax-fit="photo_2"
				src="/themes/rise-theme/dist/images/estate/character-view/ozzie/05_OzzieFamily_02@2x.png" alt="">
			<img class="photo photo-3" v-parallax-fit="photo_3"
				src="/themes/rise-theme/dist/images/estate/character-view/ozzie/06_OzzieFamily_03@2x.png" alt="">
			<img class="photo photo-4" v-parallax-fit="photo_4"
				src="/themes/rise-theme/dist/images/estate/character-view/ozzie/07_OzzieFamily_04@2x.png" alt="">
			<img class="photo photo-5" v-parallax-fit="photo_5"
				src="/themes/rise-theme/dist/images/estate/character-view/ozzie/08_OzzieFamily_05@2x.png" alt="">
			<!-- <img class="photo photo-6" v-parallax-fit="photo_6" src="/themes/rise-theme/dist/images/estate/character-view/ozzie/10_OzzieFamily_07@2x.png" alt="">
			<img class="photo photo-7" v-parallax-fit="photo_7" src="/themes/rise-theme/dist/images/estate/character-view/ozzie/09_OzzieFamily_06@2x.png" alt=""> -->
		</div>
	</div>
</template>

<script>
import { store } from '../../store';
export default {
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/ozzie/1.srt',
				'es': '/themes/rise-theme/resources/assets/audio/ozzie/1_es.srt'
			},
			mutationObserver: null,
			region_1: [
				{
					start: 0,
					end: 1500,
					fromStyle: { transform: 'scale(0)' },
					toStyle: { transform: 'scale(1)' },
					easing: 'linear'
				}
			],
			region_2: [
				{
					start: 0,
					end: 1500,
					fromStyle: { transform: 'scale(0)' },
					toStyle: { transform: 'scale(1)' },
					easing: 'linear'
				}
			],
			plane: [
				{
					start: 1500,
					end: 2500,
					fromStyle: { transform: 'scale(0) translateX(0%) translateY(0%) rotate(0deg)' },
					toStyle: { transform: 'scale(1) translateX(110%) translateY(0%) rotate(0deg)' },
					easing: 'linear'
				},
				{
					start: 2500,
					end: 3500,
					fromStyle: { transform: 'scale(1) translateX(110%) translateY(0%) rotate(0deg)' },
					toStyle: { transform: 'scale(1) translateX(190%) translateY(-50%) rotate(-90deg)' },
					easing: 'linear'
				},
				{
					start: 3500,
					end: 4500,
					fromStyle: { transform: 'scale(1) translateX(190%) translateY(-50%) rotate(-90deg)' },
					toStyle: { transform: 'scale(1) translateX(190%) translateY(-220%) rotate(-90deg)' },
					easing: 'linear'
				},
				{
					start: 4500,
					end: 5500,
					fromStyle: { transform: 'scale(1) translateX(190%) translateY(-220%) rotate(-90deg)' },
					toStyle: { transform: 'scale(1) translateX(50%) translateY(-260%) rotate(-180deg)' },
					easing: 'linear'
				},
				{
					start: 5500,
					end: 8500,
					fromStyle: { transform: 'scale(1) translateX(50%) translateY(-260%) rotate(-180deg)' },
					toStyle: { transform: 'scale(1) translateX(-520%) translateY(-260%) rotate(-180deg)' },
					easing: 'linear'
				},
				{
					start: 8500,
					end: 9500,
					fromStyle: { transform: 'scale(1) translateX(-520%) translateY(-260%) rotate(-180deg)' },
					toStyle: { transform: 'scale(1) translateX(-560%) translateY(-350%) rotate(-90deg)' },
					easing: 'linear'
				},
				{
					start: 9500,
					end: 10500,
					fromStyle: { transform: 'scale(1) translateX(-560%) translateY(-350%) rotate(-90deg)' },
					toStyle: { transform: 'scale(1) translateX(-550%) translateY(-390%) rotate(0deg)' },
					easing: 'linear'
				},
				{
					start: 10500,
					end: 11500,
					fromStyle: { transform: 'scale(1) translateX(-550%) translateY(-390%) rotate(0deg)' },
					toStyle: { transform: 'scale(1) translateX(-300%) translateY(-390%) rotate(0deg)' },
					easing: 'linear'
				}
			],
			photo_1: [
				{
					start: 4400,
					end: 5000,
					fromStyle: { transform: 'scale(0) rotate(10deg)' },
					toStyle: { transform: 'scale(1) rotate(10deg)' },
					easing: 'linear'
				}
			],
			photo_2: [
				{
					start: 5000,
					end: 5400,
					fromStyle: { transform: 'scale(0) rotate(20deg)' },
					toStyle: { transform: 'scale(1) rotate(20deg)' },
					easing: 'linear'
				}
			],
			photo_3: [
				{
					start: 6000,
					end: 6400,
					fromStyle: { transform: 'scale(0) rotate(-5deg)' },
					toStyle: { transform: 'scale(1) rotate(-5deg)' },
					easing: 'linear'
				}
			],
			photo_4: [
				{
					start: 7000,
					end: 7400,
					fromStyle: { transform: 'scale(0) rotate(25deg)' },
					toStyle: { transform: 'scale(1) rotate(25deg)' },
					easing: 'linear'
				}
			],
			photo_5: [
				{
					start: 8000,
					end: 8400,
					fromStyle: { transform: 'scale(0) rotate(5deg)' },
					toStyle: { transform: 'scale(1) rotate(5deg)' },
					easing: 'linear'
				}
			],
			photo_6: [
				{
					start: 10000,
					end: 10400,
					fromStyle: { transform: 'scale(0)' },
					toStyle: { transform: 'scale(1)' },
					easing: 'linear'
				}
			],
			photo_7: [
				{
					start: 11000,
					end: 11400,
					fromStyle: { transform: 'scale(0)' },
					toStyle: { transform: 'scale(1)' },
					easing: 'linear'
				}
			],
			route: [
				{
					start: 11500,
					end: 12000,
					fromStyle: { opacity: 0 },
					toStyle: { opacity: 1 },
					easing: 'linear'
				}
			],
			box: [
				{
					start: 12000,
					end: 20000,
					fromStyle: { transform: 'translateY(0%)' },
					toStyle: { transform: 'translateY(500%)' },
					easing: 'linear'
				}
			]
		}
	},
	created() {
		this.$watch('$route.meta', newVal => {
			this.autoStartClip = !newVal.intro;
		}, { immediate: true });
		const unwatch = this.$watch('$tutorial.value', newVal => {
			this.autoStartClip = newVal;
			this.emitter.emit('auto-play');
			unwatch();
		});
		this.$watch('store.lang', newVal => {
			if(Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });

	},

	mounted() {
		const self = this;
		const audio = '/themes/rise-theme/resources/assets/audio/ozzie/OZZIE_PART1_2_010723.mp3';
		const evidence = {
			items: [
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/ozzie/evidence/1a.png',
					url: 'https://beltmag.com/southwest-detroit-latinx-refuge/',
					link_title: {
						'en': "Finding Refuge in Southwest Detroit",
						'es': 'Encontrar refugio en el suroeste de Detroit'
					},
				},
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/ozzie/evidence/1b.png',
					url: 'https://www.theneighborhoods.org/story/detroit-celebrates-national-hispanic-heritage-month',
					link_title: {
						'en': "The Neighborhoods - city of Detroit.",
						'es': 'Los Barrios - ciudad de Detroit.'
					},
				}
			],
			text: {
				'en': 'Finding Refuge in Southwest Detroit - "To many immigrants, Detroit was a place filled with opportunity. Mexicans migrated to Detroit from the states of Jalisco, Chihuahua, Guanajuato...word carried that Detroit was not as racist toward Mexicans as other places in the United States."',
				'es': 'Encontrar refugio en el suroeste de Detroit: "Para muchos inmigrantes, Detroit era un lugar lleno de oportunidades. Los mexicanos emigraron a Detroit desde los estados de Jalisco, Chihuahua, Guanajuato... Se corrió la voz de que Detroit no era tan racista con los mexicanos como otros lugares del Estados Unidos."'
			}
		};

		const text = {
			'en': "Nearly 8% of Detroit's total population identifies as Hispanic or Latinx, based on numbers from U.S. Census Bureau. Just like the Black southerners who emigrated north in hopes of economic promise, many Chicano, Latino, and Hispanic families came to Detroit to work in the automobile, railroad, and sugar beet factory industry.",
			'es': 'Casi el 8 % de la población total de Detroit se identifica como hispana o latinx, según las cifras de la Oficina del Censo de EE. UU. Al igual que los sureños negros que emigraron al norte con la esperanza de una promesa económica, muchas familias chicanas, latinas e hispanas llegaron a Detroit para trabajar en la industria automotriz, ferroviaria y de remolacha azucarera.'
		};

		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.transform == 'scale(1) translateX(-300%) translateY(-390%) rotate(0deg)') {
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[store.lang];
					this.$evidence.value = JSON.stringify(evidence);
					this.$readMore.value = text;
				}
			});
		});
		this.mutationObserver2 = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.transform == 'scale(0)') {
					this.$evidence.value = JSON.stringify(evidence);
					this.$readMore.value = text;
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[store.lang];
				}
			});
		});

		this.$evidence.value = JSON.stringify(evidence);
		this.$readMore.value = text;
		this.$audioUrl.value = audio;
		this.$subtitlesUrl.value = this.subtitlesUrl[store.lang];

		this.mutationObserver.observe(this.$refs.plane, {
			attributes: true,
			attributeFilter: ['style']
		});
		this.mutationObserver2.observe(this.$refs.region_1, {
			attributes: true,
			attributeFilter: ['style']
		});
		self.emitter.on('player-ready', () => {
			console.log('player-ready event catch')
			setTimeout(() => {
				if (self.autoStartClip) {
					self.emitter.emit('auto-play');
				}
			}, 500);
		});

	},
	unmounted() {
		this.mutationObserver.disconnect();
		this.mutationObserver2.disconnect();
	}
}
</script>

<style lang="scss" scoped>
.box {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;

	.region-1 {
		position: absolute;
		top: -16%;
		left: -31%;
		max-width: 350px;
		transition: all 0.1s linear;
	}

	.region-2 {
		position: absolute;
		bottom: -18%;
		right: -45%;
		max-width: 450px;
		transition: all 0.1s linear;
	}

	.route-plane {
		position: absolute;
		left: -200px;
		right: -150px;
		bottom: -15px;
		height: 520px;
		transition: all 0.1s linear;

		.plane {
			width: 120px;
			position: absolute;
			right: 20%;
			bottom: -8%;
			z-index: 2;
			transition: all 0.1s linear;
			will-change: transform;
		}

		.route {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			transition: all 0.1s linear;
		}

		.photo {
			width: 150px;
			position: absolute;
			top: 0;
			left: 0;
			transition: all 0.1s linear;

			&.photo-1 {
				left: 90%;
				top: 47%;
			}

			&.photo-2 {
				left: 74%;
				top: 18%;
			}

			&.photo-3 {
				left: 49%;
				top: 17%;
			}

			&.photo-4 {
				left: 21%;
				top: 18%;
			}

			&.photo-5 {
				left: 6%;
				top: -13%;
			}

			&.photo-6 {
				left: -10%;
				top: -4%;
			}

			&.photo-7 {
				left: 11%;
				top: -25%;
			}
		}
	}
}

@media screen and (max-width: 1600px) {
	.box .region-1 {
		max-width: 300px;
	}

	.box .region-2 {
		bottom: -10%;
		right: -30%;
		max-width: 350px;
	}

	.box .route-plane {
		left: -135px;
		right: -115px;
		bottom: -4px;
		height: 445px;
	}

	.box .route-plane .photo {
		width: 120px;
	}

	.box .route-plane .plane {
		width: 100px;
		bottom: -6%;
	}
}

@media screen and (max-width: 991px) {
	.box .region-1 {
		max-width: 250px;
		top: -12%;
	}

	.box .region-2 {
		bottom: -9%;
		right: -28%;
		max-width: 270px;
	}

	.box .route-plane {
		left: -95px;
		right: -65px;
		bottom: 12px;
		height: 340px;
	}

	.box .route-plane .photo {
		width: 100px;
	}

	.box .route-plane .plane {
		width: 80px;
		bottom: -6%;
	}
}

@media screen and (max-width: 650px) {
	.box .region-1 {
		max-width: 180px;
		top: -8%;
	}

	.box .region-2 {
		bottom: -11%;
		right: -26%;
		max-width: 188px;
	}

	.box .route-plane {
		left: -50px;
		right: -35px;
		bottom: 6px;
		height: 212px;
	}

	.box .route-plane .photo {
		width: 70px;

		&.photo-1 {
			left: 87%;
		}

		&.photo-2 {
			left: 70%;
		}
	}

	.box .route-plane .plane {
		width: 50px;
		bottom: -10%;
	}
}</style>
